export const normalizeVenueId = (value) => {
  const id = typeof value === 'string' ? value.trim() : '';
  return /^[a-zA-Z0-9_-]{1,200}$/.test(id) && !/^(undefined|null)$/i.test(id) ? id : '';
};

export const getVenueIdFromSearchParams = (searchParams) =>
  normalizeVenueId(searchParams.get('venue_id') || searchParams.get('venue') || searchParams.get('venueId') || searchParams.get('id'));

export const getVenueIdFromLocationSearch = (search) => {
  const queryParams = new URLSearchParams(search);
  return getVenueIdFromSearchParams(queryParams);
};

export const resolveVenueIdFromLocation = (locationLike = window.location) => {
  const search = locationLike.search || '';
  const params = new URLSearchParams(search);
  if (['venue_id', 'venue', 'venueId', 'id'].some(key => params.has(key))) {
    return getVenueIdFromSearchParams(params);
  }
  if (search.length > 1 && !search.includes('=')) {
    try { return normalizeVenueId(decodeURIComponent(search.startsWith('?') ? search.slice(1) : search)); }
    catch { return ''; }
  }
  const parts = (locationLike.hostname || '').split('.');
  return parts.length >= 3 && parts[0] !== 'venue' ? normalizeVenueId(parts[0]) : '';
};
